import React from "react";
import { Helmet } from "react-helmet";

const Security = () => {
    return (
        <div className="legal">
            <Helmet>
                <title>Security Policy - Shopdm Pay</title>
            </Helmet>
            <div>
                <div className="h1">Shopdm Pay Security Policy</div>
                <div>Last updated: 1st September 2024</div>

                <div className="margin-top-1em">
                    At Shopdm Pay, your security is our highest priority. We follow industry-standard practices to protect sensitive information and maintain a secure environment for all transactions processed on our platform.
                </div>

                <div>
                    <div className="h2">1. PCI DSS Compliance</div>
                    Shopdm Pay does not capture, store, or process cardholder data directly. All transactions are handled by a PCI DSS-compliant Payment Gateway with over 20 years of experience in secure payment processing. This approach eliminates the risk of card data exposure within our systems.
                </div>

                <div>
                    <div className="h2">2. Data Encryption</div>
                    <ul>
                        <li><strong>Encryption in Transit:</strong> All data exchanged between users and Shopdm Pay is encrypted using TLS 1.2 or higher to prevent interception.</li>
                        <li><strong>Encryption at Rest:</strong> All user data is stored securely on Google Cloud and encrypted at rest using AES-256, a widely accepted and robust encryption standard.</li>
                    </ul>
                </div>

                <div>
                    <div className="h2">3. Web Application Security</div>
                    Our systems are built to defend against the most common web-based attacks:
                    <ul>
                        <li>Mitigations against Cross-Site Scripting (XSS) and SQL Injection are built into our technology stack.</li>
                        <li>Strict access control policies are enforced using Firebase Security Rules to prevent unauthorized access to data.</li>
                    </ul>
                </div>

                <div>
                    <div className="h2">4. Authentication & Account Security</div>
                    Shopdm Pay enforces strong access controls:
                    <ul>
                        <li>Accounts are protected using passwords and session-based authentication mechanisms.</li>
                        <li>Only authorized users may access sensitive parts of the system, such as merchant dashboards and payout information.</li>
                        <li>We encourage all users to maintain strong, unique passwords and to report any suspicious activity immediately.</li>
                    </ul>
                </div>

                <div>
                    <div className="h2">5. Platform Monitoring and Updates</div>
                    <ul>
                        <li>We routinely monitor our infrastructure for unauthorized access, vulnerabilities, and unusual behavior.</li>
                        <li>Security patches and software updates are applied regularly to keep our systems resilient to threats.</li>
                    </ul>
                </div>

                <div>
                    <div className="h2">6. Your Responsibility</div>
                    While Shopdm Pay secures its platform, users are responsible for safeguarding their own access credentials. Merchants must ensure that their passwords are kept private and only shared with authorized individuals.
                </div>

                <div>
                    <div className="h2">7. Changes To This Policy</div>
                    We may update this Security Policy from time to time. Any updates will be posted on this page and, where appropriate, we will notify users by email.
                    <br /><br />
                    This Policy was last updated: <strong>01/09/2024</strong>
                </div>
            </div>
        </div>
    );
};

export default Security;